var $ = jQuery;
(function ($) {
  "use strict";
  $(document).ready(function () {
    $.fn.extend({
      ifexists: function (callback) {
        if (this.length > 0) {
          return callback($(this));
        }
      },
    });

    $(".add-cursor").ifexists(function (elem) {
      const $cursor = $("#cursor");
      $(document).on("mousemove", function(e) {
        let x = e.clientX;
        let y = e.clientY;
        $cursor.css({
          left: x + "px",
          top: y + "px"
        });
      });

      $(".add-cursor").on("mousemove", function() {
        $cursor.addClass("cursor-hover");
      });

      $(".add-cursor").on("mouseleave", function() {
        $cursor.removeClass("cursor-hover");
      });
    });

    $(".scrolling-text").ifexists(function (elem) {
      gsap.set(".scrolling .text span", {
        opacity: "0",
        transformOrigin: "left center",
      });
      gsap
      .timeline({
        scrollTrigger: {
          trigger: ".scrolling .text",
          scrub: 0.5,
          start: "top 85%",
          end: "top 15%",
          markers: false,
        },
      })
      .to(".scrolling .text span", {
        opacity: "1",
        duration: 1,
        ease: "none",
        stagger: 1,
      });
    });

    $(".parallax").ifexists(function (elem) {
      const element = document.querySelectorAll(".parallax");
      for (let i = 0; i < element.length; i++) {
        // eslint-disable no-unused-vars, no-undef
        new Parallax(element[i]);
        // eslint-enable no-unused-vars, no-undef
      }
    });

    $(".swiper-carousels").ifexists(function () {
      let carousels = document.querySelectorAll(".swiper-carousels");

      carousels.forEach((carousel) => {
        let userOptions = {};
        if (carousel.dataset.swiperOptions) {
          userOptions = JSON.parse(carousel.dataset.swiperOptions);
        }

        const swiper = new Swiper(carousel, {
          ...userOptions,
          on: {
            init: function () {
              const isReverse = userOptions.autoplay?.reverseDirection === true;
              const isLoop = userOptions.loop === true;

              if (isLoop) {
                // Delay position change to allow Swiper to build looped slides
                requestAnimationFrame(() => {
                  if (isReverse) {
                    this.slideToLoop(this.slides.length - 1, 0, false);
                  } else {
                    this.slideToLoop(Math.floor(this.slides.length / 2), 0, false);
                  }
                });
              }
              
              $(".add-cursor-apply").ifexists(function (elem) {
                const $cursor = $("#cursor");
                $(document).on("mousemove", function(e) {
                  let x = e.clientX;
                  let y = e.clientY;
                  $cursor.css({
                    left: x + "px",
                    top: y + "px"
                  });
                });

                $(".add-cursor-apply").on("mousemove", function() {
                  $cursor.addClass("cursor-hover apply");
                });

                $(".add-cursor-apply").on("mouseleave", function() {
                  $cursor.removeClass("cursor-hover apply");
                });
              });
            },
          },
        });

        swiper.init();
      });
    });

    $(".vertical-slider").ifexists(function (elem) {
      const vertical_swiper = new Swiper(".vertical-slider", {
        direction: "vertical",
        autoplay: {
          delay: 3000000,
          disableOnInteraction: false,
        },
        speed: 3000,
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          init: function (swiper) {
            const slider = document.querySelector(".vertical-slider");
            const currentSlide = swiper.slides[swiper.activeIndex];
            const currentSlideItem = currentSlide.children[0];
            slider.style.height = currentSlideItem.clientHeight + "px";
          },
          slideChange: function (swiper) {
            const slider = document.querySelector(".vertical-slider");
            const currentSlide = swiper.slides[swiper.activeIndex];
            const currentSlideItem = currentSlide.children[0];
            slider.style.height = currentSlideItem.clientHeight + "px";
          },
        },
      });
    });

    $(".swiper-web3").ifexists(function (elem) {
      const swiperEl = document.querySelector('.swiper-web3');
      const swiperOptions = JSON.parse(swiperEl.getAttribute('data-swiper-options'));
      const swiper = new Swiper(swiperEl, swiperOptions);
      swiper.on('init', function () {
        swiper.slideTo(swiper.slides.length - 1, 0, false);
      });
      swiper.init();
    });


    $("#cv_attachment").ifexists(function (elem) {
      $("#cv_attachment").jfilestyle({
        buttonBefore: false,
        text: `
        <span class="fa-stack mx-auto mb-2">
          <i class="fa-solid fa-circle fa-stack-2x"></i>
          <i class="fa-solid fa-plus fa-stack-1x fa-inverse"></i>
        </span>
        Drag & Drop or click to choose doc,docx and pdf
        <small class="mt-2">Maximum file size: <strong>8mb</strong></small>
        `,
        dragdrop: false,
        inputSize: "100%",
        disabled: false,
      });
      $("#apply").validate({
        rules: {
          Name: "required",
          Email: {
            required: true,
            email: true,
          },
          CV: {
            required: true,
            extension: "pdf|doc|docx",
          },
          tos: "required",
        },
        messages: {
          Name: "Please enter your Full Name",
          Email: "Please enter your Email",
          CV: "Please add your CV",
          tos: "Please accept our policy",
        },
      });
    });

    AOS.init();
  });
})(jQuery);
